import {
  privatePostApi,
  privateGetApi,
  privatePutApi,
  privateDeleteApi,
  buildApiUrl,
} from "../../utils/apiHelper";
import axios from "axios";
import { contacts, tags } from "../slices/contactsSlice";

export const listContacts = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    privateGetApi("/contacts", payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(contacts(response.data.result));
          resolve();
        } else {
          reject(response.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const listTags = (payload) => (dispatch) => {
  return new Promise((resolve, reject) => {
    privateGetApi("/contacts/tags", payload)
      .then((response) => {
        if (response.status === 200) {
          dispatch(tags(response.data.result));
          resolve();
        } else {
          reject(response.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const createContact = (payload) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/contacts", payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const readContact = (payload, id) => () => {
  return new Promise((resolve, reject) => {
    privateGetApi("/contacts/" + id, payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const updateContact = (payload, id) => () => {
  return new Promise((resolve, reject) => {
    privatePutApi("/contacts/" + id, payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const deleteContact = (id) => () => {
  return new Promise((resolve, reject) => {
    privateDeleteApi("/contacts/" + id)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject();
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const previewImportContacts = (payload) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/contacts/import/preview", payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const importContacts = (payload) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/contacts/import", payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const importAllContacts = (payload) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/contacts/import/all", payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const bulkUpdateContactTags = (payload) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/contacts/bulk-tags", payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const importUpdateContactTags = (payload) => () => {
  return new Promise((resolve, reject) => {
    privatePostApi("/contacts/import/update-tags", payload)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data.result);
        } else {
          reject(response.message);
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export const exportContacts = ({
  format = "csv",
  search,
  tags,
  ids,
  columns,
} = {}) => {
  const query = { format };
  if (ids?.length) {
    query.ids = ids.join(",");
  } else {
    if (search?.trim()) query.search = search.trim();
    if (tags?.length) query.tags = tags.join(",");
  }
  if (columns?.length) query.columns = columns.join(",");
  const accessToken = localStorage.getItem("accessToken");
  return axios.get(buildApiUrl("/contacts/export", query), {
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: ["csv", "xlsx"].includes(format) ? "blob" : "json",
  });
};
